import { render, staticRenderFns } from "./act-login.vue?vue&type=template&id=2461cde7&scoped=true&"
import script from "./act-login.vue?vue&type=script&lang=js&"
export * from "./act-login.vue?vue&type=script&lang=js&"
import style0 from "./act-login.vue?vue&type=style&index=0&id=2461cde7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461cde7",
  null
  
)

export default component.exports